import { mapState, mapGetters, mapActions } from 'vuex'

export const mockupResendMailComputed = {
  ...mapState('sendMail', {}),
  ...mapGetters('sendMail', [
    'sendMailBooking',
    'sendMailBookingSuccess',
    'getIsLoading',
  ]),
}

export const mockupResendMailMethods = mapActions('sendMail', [
  'sendMail',
  'sendMailInit',
])
